export default {
  title: 'Program de recenzii Google',
  sections: {
    google_review_settings: 'Setări program de recenzii Google',
  },
  form: {
    reward: {
      label: 'Recompensă (puncte)',
      point_value: '100 puncte = {{moneyValue}}',
    },
    has_end_date: {
      label: 'Durată',
      options: {
        false: 'Infinit',
        true: 'Cu dată de sfârșit specificată',
      },
    },
    end_date: {
      label: 'Dată de sfârșit',
    },
  },
  tags: {
    inactive: 'Inactiv',
    active: 'Activ',
    expired: 'Expirat',
  },
  buttons: {
    save: 'Salvare',
  },
  toasts: {
    failed_to_load_data: 'Încărcarea datelor a eșuat',
    changes_got_saved: 'Modificările au fost salvate',
    failed_to_save_changes: 'Salvarea modificărilor a eșuat',
  },
};
